import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = ({ scannerCode, onGenerateCode }) => {
  const navigate = useNavigate();

  const quickActionItems = [
    {
      label: 'Create Event',
      description: 'Start new event setup',
      icon: 'Plus',
      variant: 'default',
      onClick: () => navigate('/create-event')
    },
    {
      label: 'Add Venue',
      description: 'Register new venue',
      icon: 'MapPin',
      variant: 'outline',
      onClick: () => navigate('/create-venue')
    },
    {
      label: 'Scanner Access',
      description: 'Open ticket scanner',
      icon: 'QrCode',
      variant: 'outline',
      onClick: () => navigate('/event-scanner')
    },
    {
      label: 'View Reports',
      description: 'Financial analytics',
      icon: 'BarChart3',
      variant: 'outline',
      onClick: () => navigate('/reports')
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {quickActionItems?.map((action, index) => (
          <Button
            key={index}
            variant={action?.variant}
            onClick={action?.onClick}
            iconName={action?.icon}
            iconPosition="left"
            className="h-auto p-4 flex-col items-start text-left"
          >
            <span className="font-medium mb-1">{action?.label}</span>
            <span className="text-xs opacity-75">{action?.description}</span>
          </Button>
        ))}
      </div>
      <div className="border-t border-border pt-4">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="text-sm font-medium text-foreground mb-1">Scanner Code</h4>
            <p className="text-xs text-muted-foreground">6-digit access code for event scanning</p>
          </div>
          <div className="flex items-center space-x-3">
            {scannerCode ? (
              <div className="bg-muted px-3 py-2 rounded-md">
                <span className="text-lg font-mono font-bold text-foreground">{scannerCode}</span>
              </div>
            ) : (
              <span className="text-sm text-muted-foreground">No active code</span>
            )}
            <Button
              variant="outline"
              size="sm"
              iconName="RefreshCw"
              onClick={onGenerateCode}
            >
              Generate
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;